export const lang = {
    DaofuCounty:'Daofu County',
    weathertxt:'three day weather',
    y:'Y',
    m:'M',
    d:'D',
    sys:'scan',
    gzwxgzh:'Follow wechat public account',
    zxrx:'Counsel',
    tsrx:'Complaint',
    jyrx:'Rescue',
    lyjgfwpt:'Supervision',
    gfwz:'Official website',
    dcdf:'多彩道孚e',
    dlwz:'地理位置e',
    qhhj:'气候环境e',
    whdy:'文化底蕴e',
    mzfq:'民族风情e',
    fywh:'heritage',
    yywh:'music',
    wdwh:'dance',
    fswh:'clothing',
    ycwh:'show',
  }
  


// WEBPACK FOOTER //
// ./src/assets/i18/en.js